"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortDirection = void 0;
var SortDirection;
(function (SortDirection) {
    SortDirection["Ascending"] = "Ascending";
    SortDirection["Descending"] = "Descending";
})(SortDirection = exports.SortDirection || (exports.SortDirection = {}));
//# sourceMappingURL=Sort.js.map